import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { Caret, TriggerButton } from "commons";
import { getDefaultAnalysisDateRange } from "commons/src/NuDateUtils";

import { routes } from "../../helpers/RouteHelpers";

const DEFAULT_RANGE = getDefaultAnalysisDateRange().id;

export function AccountLink({ label, target, account, range = DEFAULT_RANGE }) {
    return (
        <PlainLink
            to={routes.client[target]({
                accountNum: account,
                rangeId: range
            })}
            data-testid={`${target}-link`}
        >
            <Button>
                {label}
                <Caret direction="right" colour="primary" />
            </Button>
        </PlainLink>
    );
}

const PlainLink = styled(Link)`
    text-decoration: none;
`;

const Button = styled(TriggerButton)`
    height: 30px;
    width: 130px;
    max-width: 130px;
    background-color: white;
    border: 1px solid ${props => props.theme.primary};
    color: ${props => props.theme.primary};
    margin-left: 1rem;
    padding: 0 0 0 12px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 600px) {
        margin: 0;
    }
`;

AccountLink.propTypes = {
    label: PropTypes.string.isRequired,
    target: PropTypes.oneOf(["analysis", "transactions", "incomeHistory"]).isRequired,
    account: PropTypes.string.isRequired,
    range: PropTypes.string
};
